@use '@lib/assets/styles/main.scss' as *;

.documentList {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.documentRow {
  display: grid;
  grid-template-columns: 350px 150px auto;
  align-items: center;
  gap: 16px;
}

.documentRowPreview {
  min-width: 0;
}

.documentRowTime {
  color: $gray700;
  white-space: nowrap;
}

.supportiveMessageWrap {
  width: 100%;
}
